import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { FeatureIcon } from '@ui/components/FeatureIcon/FeatureIcon'
import { Modal } from '@ui/components/Modal'
import { CircleCheckIcon } from '@ui/icons/CircleCheck.icon'

import { Box } from '@shared/components/Box'

interface LabeledItem {
  label: string
  value: React.ReactNode
}

interface Props {
  title?: string
  description?: React.ReactNode
  items?: LabeledItem[]
  primaryLabel?: string
  secondaryLabel?: string
  onPrimaryClick?: () => void
  onSecondaryClick?: () => void
}

export const SuccessModal: BaseModalType<Props> = (props) => {
  const { t } = useTranslation()
  const { title = t('Success'), description, items, close } = props
  const { primaryLabel = t('OK'), secondaryLabel, onPrimaryClick, onSecondaryClick } = props

  const handlePrimary = () => {
    onPrimaryClick?.()
    close()
  }

  const handleSecondary = () => {
    onSecondaryClick?.()
    close()
  }

  return (
    <Modal>
      <Modal.Body centered>
        <FeatureIcon size='lg' icon={CircleCheckIcon} bg='surface-secondary-high-em' />
        <Modal.Body.Title color='text-high-em'>{title}</Modal.Body.Title>
        {description && <Modal.Body.Text>{description}</Modal.Body.Text>}
        {items && items.length > 0 && (
          <Box fullWidth>
            {items.map((it, idx) => (
              <Modal.Body.LabeledInfo
                key={`item-${idx}`}
                label={it.label}
                value={it.value?.toString() ?? ''}
              />
            ))}
          </Box>
        )}
      </Modal.Body>
      <Modal.Footer>
        {secondaryLabel && (
          <Modal.Footer.Secondary onClick={handleSecondary}>
            {secondaryLabel}
          </Modal.Footer.Secondary>
        )}
        <Modal.Footer.Primary onClick={handlePrimary}>{primaryLabel}</Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
